import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useForm } from "react-hook-form";
import { useAuth } from "./../util/auth";
import { useRouter } from "../util/router";

function SettingsGeneral(props) {
  const auth = useAuth();
  const [pending, setPending] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const { register, handleSubmit, errors } = useForm();
  const router = useRouter();

  const onSubmit = (data) => {
    setPending(true);

    return auth
      .updateProfile(data)
      .then(() => {
        props.onStatus({
          type: "success",
          message: "Your profile has been updated",
        });
      })
      .catch((error) => {
        if (error.code === "auth/requires-recent-login") {
          props.onStatus({
            type: "requires-recent-login",
            callback: () => onSubmit(data),
          });
        } else {
          props.onStatus({
            type: "error",
            message: error.message,
          });
        }
      })
      .finally(() => {
        setPending(false);
      });
  };

  const handleUnsubscribe = async () => {
    setPending(true);
    try {
      const res = await fetch("/api/unsubscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: auth.user.uid }),
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result.message);

      props.onStatus({
        type: "success",
        message: "You have been unsubscribed successfully",
      });
      router.push("/");
    } catch (err) {
      props.onStatus({
        type: "error",
        message: err.message,
      });
    } finally {
      setPending(false);
      setConfirmOpen(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              type="text"
              label="Name"
              name="name"
              placeholder="Name"
              defaultValue={auth.user.name}
              error={errors.name ? true : false}
              helperText={errors.name && errors.name.message}
              fullWidth
              inputRef={register({
                required: "Please enter your name",
              })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              type="email"
              label="Email"
              name="email"
              placeholder="user@example.com"
              defaultValue={auth.user.email}
              error={errors.email ? true : false}
              helperText={errors.email && errors.email.message}
              fullWidth
              inputRef={register({
                required: "Please enter your email",
              })}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              disabled={pending}
              fullWidth
            >
              {!pending && <span>Save</span>}
              {pending && <CircularProgress size={28} />}
            </Button>
          </Grid>
        </Grid>
      </form>

      <Button
        variant="contained"
        color="secondary"
        size="large"
        disabled={pending}
        fullWidth
        style={{ marginTop: "10px" }}
        onClick={() => setConfirmOpen(true)}
      >
        Unsubscribe
      </Button>

      {/* Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Unsubscribe</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to unsubscribe? This will remove all your data
            (credits, orders, transactions, and items).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="default">
            Cancel
          </Button>
          <Button
            onClick={handleUnsubscribe}
            color="secondary"
            disabled={pending}
          >
            {pending ? <CircularProgress size={20} /> : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SettingsGeneral;
